var annee = new Date().getFullYear();
document.querySelector(".annee").innerHTML = annee;


